import React from 'react';

const context = React.createContext({
  config: {},
});

export default context;